import { useEffect, useState } from "react";
import { Toaster, toast } from "sonner";
import { api } from "./lib/api";
import { FlowSphereLogo } from "./components/FlowSphereLogo";
import InvitationPage from "./public/InvitationPage";
import PublicSite from "./public/PublicSite";
import SetupWizard from "./public/SetupWizard";
import ResetPassword from "./public/ResetPassword";
import Login from "./views/Login";
import Workspace from "./views/Workspace";
import "@/App.css";
import "@/concierge.css";

const currentPath = () => window.location.pathname;

function App() {
  const [user, setUser] = useState(null);
  const [checking, setChecking] = useState(true);
  const [route, setRoute] = useState(currentPath);

  useEffect(() => {
    api.get("/auth/me").then((response) => setUser(response.data)).catch(() => {}).finally(() => setChecking(false));
    const onPopState = () => setRoute(currentPath());
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, []);

  const navigate = (path) => {
    window.history.pushState({}, "", path);
    setRoute(currentPath());
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const handleLogout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(null); navigate("/"); toast.success("Signed out safely");
  };

  if (checking) return <div className="loading-screen" data-testid="app-loading-screen"><FlowSphereLogo variant="loading"/><span>Preparing FlowSphere…</span></div>;

  let content;
  if (route === "/invitation") content = <InvitationPage navigate={navigate}/>;
  else if (route === "/reset-password") content = <ResetPassword onLogin={setUser} navigate={navigate}/>;
  else if (route === "/setup") content = <SetupWizard navigate={navigate}/>;
  else if (user) content = <Workspace user={user} onLogout={handleLogout}/>;
  else if (route === "/login") content = <Login onLogin={setUser} navigate={navigate}/>;
  else content = <PublicSite navigate={navigate}/>;

  return <>{content}<Toaster position="top-right" richColors closeButton/></>;
}

export default App;